var $63160cfb5ee507f0$exports = {};
$63160cfb5ee507f0$exports = {
    "collectionLabel": `Javaslatok`
};


export {$63160cfb5ee507f0$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
